import { Radio as AntRadio, RadioGroupProps } from "@basic-components";

interface RadioOptionType {
  label: string;
  value: string | number;
}

export const Radio = ({ label = '', isView, value, options = [], ...rest }: { label: string; isView?: boolean, options: RadioOptionType[] } & RadioGroupProps) => {
  if (isView) {
    return options.find((item: RadioOptionType) => item.value === value)?.label || '--';
  }
  return (   
    <AntRadio.Group
      name="radiogroup"
      value={value}
      options={options}
      {...rest}
    />
  );
};